var keys = function keys(value) {
  return value ? Object.keys(value) : [];
};

export default keys;